module.exports = {"id":7,"name":"Wedding sensation","price":0,"dimensions":{"margin":{"top":20,"right":20,"bottom":20,"left":20}},"sizes":[{"label":"27x20","isCover":true,"photo_cover":true,"placeholderBorderSize":31,"width":190,"height":60,"margin":{"top":5,"right":5,"bottom":5,"left":5},"resolution":300,"midline_front":114,"midline_back":114,"placeholders":[{"left":0,"top":0,"width":190,"height":60}]}]}


//////////////////
// WEBPACK FOOTER
// ./src/config/templates/covers/pro/landscape/wedding_sensation.json
// module id = 893
// module chunks = 0